module.exports = __webpack_public_path__ + "img/mri.a2ef8dbe.png";